import {Button, IconButton, MenuItem, TextField} from '@material-ui/core'
import {useFormik} from 'formik'
import {Box} from 'reoil'
import {EducationDetailItem} from '../../hooks/api/useFechResume'
import {SubTitle} from '../../pages/UserResumeEditPage'
/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx, css} from '@emotion/core'
import {useThemeValue} from '../../store/themeState'
import {rgba} from 'polished'
import {MdAdd, MdDelete} from 'react-icons/md'
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import dateUtils from '@date-io/dayjs'
import localZh from 'dayjs/locale/zh'

// 排名
const rankings = ['前10%', '前25%', '前50%', '其他']

// 学历列表
const educationLevels = ['其他', '大学本科', '硕士研究生', '博士研究生']

interface EduExperienceProps {
  educationDetailList: EducationDetailItem[]
  onBlur: (values: EducationDetailItem[]) => void
}

const EduExperience: React.FC<EduExperienceProps> = ({
  educationDetailList = [],
  onBlur
}) => {
  const theme = useThemeValue()

  const formik = useFormik({
    initialValues: educationDetailList,
    validate: values => {
      onBlur(values)
    },
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values => {}
  })

  const handleClickAdd = () => {
    formik.setValues(values =>
      values.concat({
        school: '',
        fromdate: '',
        todate: '',
        department: '',
        major: '',
        majorRanking: '',
        userid: '',
        sort: '',
        degree: ''
      })
    )
  }

  const handleClickClose = (index: number) => {
    formik.setFormikState(form => {
      delete form.values[index]

      return {
        ...form,
        values: form.values.filter(item => item)
      }
    })
  }

  return (
    <MuiPickersUtilsProvider utils={dateUtils} locale={localZh}>
      <Box
        className='EduExperience'
        stretch
        mb={3}
        css={css`
          .series span {
            transform-origin: left top;
            transform: scale(3.6);
          }
          .field {
            margin-bottom: 8px;
          }
        `}>
        <SubTitle>
          教育经历
          <i style={{color: 'orangered'}}>*</i>
          <span
            style={{
              marginLeft: 8,
              color: 'gray',
              fontSize: 14,
              fontWeight: 'normal'
            }}>
            (请填写大学本科以上所有教育经历)
          </span>
        </SubTitle>

        {formik.values &&
          formik.values.map((item, i) => (
            <Box
              className='part'
              key={i}
              border='divider'
              borderRadius={8}
              p={2}
              mb={3}
              stretch>
              <Box
                className='series'
                fontWeight='bold'
                fontSize={1}
                color={rgba(theme.colors.primary, 0.16)}
                mb={1}>
                <span>{i + 1}</span>
              </Box>
              <Box
                position='absolute'
                style={{zIndex: 2}}
                right={0}
                onClick={() => handleClickClose(i)}>
                <IconButton className='close'>
                  <MdDelete />
                </IconButton>
              </Box>
              <TextField
                className='field'
                label='学校名称'
                name={`[${i}].school`}
                value={item.school || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <DatePicker
                className='field'
                label='入学日期'
                cancelLabel='取消'
                openTo='year'
                okLabel='确定'
                format='YYYY-MM-DD'
                name={`[${i}].fromdate`}
                value={item.fromdate || null}
                onChange={date =>
                  formik.setFieldValue(
                    `[${i}].fromdate`,
                    date?.format('YYYY-MM-DD')
                  )
                }
                onBlur={formik.handleBlur}
              />
              <DatePicker
                className='field'
                label='毕业日期'
                cancelLabel='取消'
                openTo='year'
                okLabel='确定'
                format='YYYY-MM-DD'
                name={`[${i}].todate`}
                value={item.todate || null}
                onChange={date =>
                  formik.setFieldValue(
                    `[${i}].todate`,
                    date?.format('YYYY-MM-DD')
                  )
                }
                onBlur={formik.handleBlur}
              />
              <TextField
                className='field'
                label='院系'
                name={`[${i}].department`}
                value={item.department || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TextField
                className='field'
                label='专业'
                name={`[${i}].major`}
                value={item.major || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <TextField
                className='field'
                label='专业排名'
                name={`[${i}].majorRanking`}
                value={item.majorRanking || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                select>
                {rankings.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                className='field'
                label='学历'
                name={`[${i}].degree`}
                value={item.degree || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                select>
                {educationLevels.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          ))}

        <Button variant='contained' onClick={handleClickAdd}>
          <MdAdd size={20} />
          新增
        </Button>
      </Box>
    </MuiPickersUtilsProvider>
  )
}

export default EduExperience
